import { createFileRoute } from '@tanstack/react-router';

import { SettingsLayout, settingsLayoutBeforeLoad } from '@/pages/settings/layout';

export const Route = createFileRoute('/settings')({
    beforeLoad: settingsLayoutBeforeLoad,
    component: SettingsLayout,
});
